import styled from 'styled-components'
import { Colors, Typography } from 'styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
  width: 100%;
`

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Title = styled.p`
  font-weight: 800;
  font-size: 1.8rem;
  color: ${Colors.GREY[400]};
  font-family: Inter;
  letter-spacing: -${Typography.LETTER_SPACING_1}px;
  text-align: center;
  margin: 0;
`

export const Description = styled.p`
  font-weight: 400;
  font-size: 1rem;
  color: ${Colors.GREY[200]};
  font-family: Inter;
  letter-spacing: -${Typography.LETTER_SPACING_1}px;
  margin: 0;
`

export const Url = styled.a`
  color: ${Colors.PURPLE[400]};
`

export const IntegrationInfoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const IntegrationInfoText = styled.p`
  font-weight: 300;
  font-size: 1rem;
  color: ${Colors.GREY[400]};
  font-family: Inter;
  letter-spacing: -${Typography.LETTER_SPACING_1}px;
  margin: 0;
`

export const IntegrationWarnText = styled.p`
  font-weight: 300;
  font-size: 0.8rem;
  color: ${Colors.GREY[400]};
  font-family: Inter;
  letter-spacing: -${Typography.LETTER_SPACING_1}px;
  margin: 0;
  font-style: italic;
`
